import { isEmail, isMobilePhone, length } from 'class-validator';
import { activePhoneRegex, activeEmailRegex, fullNameRegex } from '@hilma/netina2all';

import { createRules } from '../../functions';

export const profilePersonalDetailsRules = createRules({
	fullName: { regex: fullNameRegex, name: i18n => i18n.pdr.fullName, greaterThan: 2, smallerThan: 45, required: true },
	phone: { activeRegex: activePhoneRegex, required: true, classValidator: (value: string) => isMobilePhone(value, 'he-IL') && (new RegExp(/^\d+/)).test(value) && length(value, 10, 10) },
	email: { activeRegex: activeEmailRegex, required: true, classValidator: (value: string) => isEmail(value) },
	address: { required: true },
});